import { render, staticRenderFns } from "./Rfb3.vue?vue&type=template&id=15c72710&"
import script from "./Rfb3.vue?vue&type=script&lang=js&"
export * from "./Rfb3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports